import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var WhyOrderCancelledIA = function WhyOrderCancelledIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize), IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "JDvEit",
    defaultMessage: "Accounts must be verified to receive orders from brands on Faire"
  });
};
var WE_VERIFY_ALL_NEW_ACCOUNTS = function WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize) {
  return strictLocalize({
    id: "3HQ2jm",
    defaultMessage: "We verify all new accounts to maintain a safe marketplace. If your account can’t be verified, any existing orders will be canceled — you won’t be charged."
  });
};
var IF_YOU_HAVE_ANY_QUESTIONS = function IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "WVf5FE",
    defaultMessage: "If you have any questions, continue to contact us and we’ll get back to you as soon as possible."
  });
};